import { useState, useEffect } from 'react'
import { WifiOff, Wifi } from 'lucide-react'
import { setupOfflineDetection } from '@/utils/serviceWorker'

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showIndicator, setShowIndicator] = useState(!navigator.onLine)

  useEffect(() => {
    const cleanup = setupOfflineDetection((online) => {
      setIsOnline(online)
      
      if (!online) {
        setShowIndicator(true)
      } else {
        // Hide indicator after a short delay when coming back online
        setTimeout(() => setShowIndicator(false), 3000)
      }
    })

    return cleanup
  }, [])

  if (!showIndicator) {
    return null
  }

  return (
    <div
      className={`
        fixed top-4 left-1/2 transform -translate-x-1/2 z-50
        px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2
        transition-all duration-300
        ${isOnline 
          ? 'bg-green-600 text-white' 
          : 'bg-red-600 text-white'
        }
      `}
    >
      {isOnline ? (
        <>
          <Wifi className="w-4 h-4" />
          <span className="text-sm font-medium">Back online</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4" />
          <span className="text-sm font-medium">You're offline</span>
        </>
      )}
    </div>
  )
}

export default OfflineIndicator